export const LOTTIE_FILE_URL = {
    // 轉場頁動畫
    transitionLoading: 'https://assets.fevercdn.com/promotion/lottie-file/transition-loading.json'
};
